<template lang="pug">
  .order-detail
    el-card(v-watermark="'in'" style="overflow:hidden")
      h4 订单信息
      el-row
        el-col(:span="8") 订单编号：{{ info.paxJourneyGuid }}
        el-col(:span="8") 创建时间：{{ info.createTimeName }}
        el-col(:span="8") 订单状态：{{ info.paxOrderStatus }}
      el-row
        el-col(:span="8") 上车时间：{{ info.aboardTimeName }}
        el-col(:span="8") 出发经度：{{ info.origin.location.lon }}
        el-col(:span="8") 出发纬度：{{ info.origin.location.lat }}
      el-row
        el-col(:span="8") 出发省份：{{ info.origin.provinceName }}
        el-col(:span="8") 出发城市：{{ info.origin.cityName }}
        el-col(:span="8")
          span 出发地址：
          el-tooltip(:content="info.origin.longAddr" placement="top")
            span {{ info.origin.shortAddr }}
      el-row
        el-col(:span="8") 到达时间：{{ info.arriveTimeName }}
        el-col(:span="8") 终点经度：{{ info.destination.location.lon }}
        el-col(:span="8") 终点纬度：{{ info.destination.location.lat }}
      el-row
        el-col(:span="8") 终点省份：{{ info.destination.provinceName }}
        el-col(:span="8") 终点城市：{{ info.destination.cityName }}
        el-col(:span="8")
          span 终点地址：
          el-tooltip(:content="info.destination.longAddr" placement="top")
            span {{ info.destination.shortAddr }}
      hr
      h4 乘客信息
      el-row
        el-col(:span="8") 姓名：{{ info.passengerInfo.userName }}
        el-col(:span="8") 手机号：{{ info.passengerInfo.mobile }}
        el-col(:span="8") 身份证号：{{ info.passengerInfo.idCard }}
      el-row
        el-col(:span="8") 性别：{{ info.passengerInfo.gender | gender }}
      hr
      h4 车主信息
      el-row
        el-col(:span="8") 姓名：{{ info.driverInfo.userName }}
        el-col(:span="8") 手机号：{{ info.driverInfo.mobile }}
        el-col(:span="8") 身份证号：{{ info.driverInfo.idCard }}
      el-row
        el-col(:span="8") 性别：{{ info.driverInfo.gender | gender }}
      hr
      h4 车辆信息
      el-row
        el-col(:span="8") 车辆名称和型号：{{ info.carType }}
        el-col(:span="8") 车辆颜色：{{ info.carColor }}
        el-col(:span="8") 车牌号：{{ info.plateNumber }}
      hr
      h4 同行乘客
      el-row
        el-col(:span="8") 是否拼车：{{ info.poolStatus }}
        el-col(:span="8") 乘客人数：{{ info.passengerCount }}
      el-row
        el-col(:span="24")
          el-table(:data="info.sameJourneyList")
            el-table-column(prop="passengerInfo.userName" label="乘客姓名")
            el-table-column(prop="passengerInfo.mobile" label="手机号")
            el-table-column(prop="passengerInfo.idCard" label="身份证号")
            el-table-column(label="订单编号")
              template(slot-scope="scope")
                a(
                  :href="`/#/order/hitch/detail?guid=${scope.row.paxJourneyGuid}`"
                  target="_blank"
                  style="text-decoration: underline"
                ) {{ scope.row.paxJourneyGuid }}
      //- h4 行车轨迹
      //- a-map.map(ref="amap" style="width: 100%;height: 500px;")
</template>

<script>
import AMap from '@/components/AMap';
import { findHitchJourneyDetail } from '@/api/hitch';
import deepCopy from '@/utils/deepCopy';

const defaultModel = {
  sameJourneyList: [],
  origin: {
    location: {},
  },
  destination: {
    location: {},
  },
  passengerInfo: {},
  driverInfo: {},
  driverReportPointList: [],
};
export default {
  components: {
    AMap
  },
  filters: {
    gender(val) {
      return {
        1: '男',
        2: '女',
      }[+val];
    },
  },
  data() {
    return {
      info: deepCopy(defaultModel),
    };
  },
  async mounted() {
    this.loadData();
  },
  methods: {
    async loadData() {
      const { guid } = this.$route.query;
      const { data } = await findHitchJourneyDetail(guid);
      this.info = Object.assign(deepCopy(defaultModel), data);

      // if (this.info.driverReportPointList) {
      //   this.map = await this.$refs.amap.getMap();
      //   const polyline = new window.AMap.Polyline({
      //     path: this.info.driverReportPointList.map(({ lon, lat }) => ({
      //       longitude: lon,
      //       latitude: lat,
      //     })),
      //     strokeColor: 'red',
      //   });
      //   this.map.add(polyline);
      //   this.map.setFitView(polyline);
      // }
    },
  },
};
</script>

<style lang="less" scoped>
.order-detail {
  max-height: 100%;
  width: 100%;
  padding: 12px 20px;
  font-size: 14px;
  overflow: auto;

  p, .el-row {
    margin: 14px 0;
  }
  h4 {
    margin-top: 8px;
  }

  hr {
    border: none;
    border-bottom: solid 1px #eee;
    margin: 20px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/order/hitch/detail.vue?5d6dff3c